import { ROUTES } from '@router'

export const mergeDescriptionToGrades = ({ grades, gradesDescription }) => {
  return grades.map((grade) => {
    const { images, paragraphs } =
      gradesDescription.find(
        (description) =>
          grade.backboxGrade.value === description.backboxGrade.value,
      ) || {}

    return {
      ...grade,
      link: {
        ...grade.link,
        name: ROUTES.PRODUCT.HOME,
      },
      images,
      paragraphs,
    }
  })
}
